module.exports = __webpack_public_path__ + "static/media/history.18302908.svg";